import { render, staticRenderFns } from "./ProductItem.vue?vue&type=template&id=3f33c2a4&scoped=true"
import script from "./ProductItem.vue?vue&type=script&lang=js"
export * from "./ProductItem.vue?vue&type=script&lang=js"
import style0 from "./ProductItem.vue?vue&type=style&index=0&id=3f33c2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f33c2a4",
  null
  
)

export default component.exports